export function largeNumberAbbreviator(num) {
  num = parseInt(num, 10);
  if (isNaN(num)) { return num; }
  if (num == null) {
    return '0';
  }
  if (num >= 1000000000) {
    return `${(num / 1000000000).toFixed(1).replace(/\.0$/, '')}B`;
  }
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return num.toFixed(0);
}

export function percentage(num) {
  num = parseInt(num, 10);
  if (isNaN(num)) { return num; }
  return `${Math.round(num)}%`;
}

export function dollar(num) {
  num = parseInt(num, 10);
  if (isNaN(num)) { return num; }
  return `$${num.toFixed(2)}`;
}

export function largeNumberAbbreviatorWithDecimal(num) {
  if (!num || isNaN(num)) { return { value: 0, symbol: '' }; }
  num = parseFloat(num.toFixed(2));
  if (num == null) {
    return { value: '0', symbol: '' };
  }

  // Handle negative numbers by getting absolute value first
  const isNegative = num < 0;
  const absNum = Math.abs(num);

  let value;
  let symbol;

  if (absNum >= 1000000) {
    // For millions ($1M+)
    value = (absNum / 1000000).toFixed(2).replace(/\.?0+$/, '');
    symbol = 'M';
  } else if (absNum >= 1000) {
    // For thousands ($1,000 - $999,999)
    value = (absNum / 1000).toFixed(2).replace(/\.?0+$/, '');
    symbol = 'K';
  } else {
    // For small amounts ($1-$999)
    value = absNum.toFixed(2).replace(/\.?0+$/, '');
    symbol = '';
  }

  // Add negative sign back if needed
  return {
    value: isNegative ? `-${value}` : value,
    symbol
  };
}

export function largeIntegerAbbreviator(num) {
  num = parseInt(num, 10);
  if (isNaN(num)) { return { value: num, symbol: '' }; }
  if (num == null) {
    return { value: '0', symbol: '' };
  }
  if (num >= 1000000000) {
    return { value: num / 1000000000, symbol: 'B' };
  }
  if (num >= 1000000) {
    return { value: num / 1000000, symbol: 'M' };
  }
  return { value: Intl.NumberFormat('en-US').format(num), symbol: '' };
}
